import { useCallback } from "react";
import { readConnectorDownloads, type ConnectorDownloads } from "../../api/connectorReleasesApi";
import { useLoad, type LoadState } from "../../shared/loading/useLoad";
import { browserSystem, offerFor, type SystemOffer } from "./connectorLinks";

/** The offered release of this server's release channel, read once for the connect steps and their first body. */
export function useConnectorDownloads(): { readonly downloads: LoadState<ConnectorDownloads>; readonly reload: () => void } {
  const load = useCallback((signal: AbortSignal) => readConnectorDownloads(signal), []);
  const { state, reload } = useLoad(load);
  return { downloads: state, reload };
}

/** What this browser's system is offered, once the release is read. */
export function browserOffer(downloads: LoadState<ConnectorDownloads>): SystemOffer | null {
  return downloads.status === "loaded" ? offerFor(downloads.value, browserSystem(navigator.userAgent)) : null;
}
